import React, { useState, useEffect } from 'react';
import v from '../../utils/Verifiers';
import Barcode from 'react-barcode';
import CloseButton from '../sharecomponents/CloseButton';
import VainillaDialog from '../sharecomponents/vanilladialog';
import EtiquetaBarcode from './EtiquetaBarcode';
import HojaEtiquetasBarcode from './HojaEtiquetasBarcode';
import HojaEtiquetasBarcodeVer2 from './HojaEtiquetasBarcodeVer2';

const EtiiquetasBarCodePDF = (p) => {
    const close = p.close ?? (() => { });
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [etiquetas, setetiquetas] = useState([]);
    const [etiquetas_filtradas, setetiquetas_filtradas] = useState([]);
    const [clasificaciones, setclasificaciones] = useState({ dias: [], usuarios: [], bloques: [] });
    const [selecciones, setselecciones] = useState({ dia: '', usuario: '', bloque: '', impresion: '' });
    const dias = ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO'];
    useEffect(() => {
        getEtiquetas();
    }, []);

    const getEtiquetas = async () => {
        let resp = await v.getDataAPI('/ordenes_trabajo/siembra/etiquetas/generar', v.getLS('impresor_etiquetas') ?? {}, setloader, setdialog);
        if (!resp.estatus) return;
        setetiquetas(resp.data);
        setetiquetas_filtradas(resp.data);

        resp.clasificaciones.dias.sort((a, b) => a - b);
        resp.clasificaciones.usuarios.sort((a, b) => {
            if (a.toLowerCase() < b.toLowerCase()) return -1;
            if (a.toLowerCase() > b.toLowerCase()) return 1;
            return 0;
        });
        resp.clasificaciones.bloques.sort((a, b) => {
            if (a.toLowerCase() < b.toLowerCase()) return -1;
            if (a.toLowerCase() > b.toLowerCase()) return 1;
            return 0;
        });
        setclasificaciones(resp.clasificaciones);
    }

    const refrescarDesdeHijo = async () => {
        await getEtiquetas();
        filttrarEtiquetas({ target: { name: '', value: '' } });
    }

    const filttrarEtiquetas = (e) => {
        let { name, value } = e.target;

        let newSelecciones = name !== "" ? { ...selecciones, [name]: value } : { ...selecciones };
        setselecciones(newSelecciones);
        let filtradas = etiquetas.filter((etiqueta) => {
            let { dia, asignado_a, bloque } = etiqueta;
            if (newSelecciones.bloque !== '' && bloque !== newSelecciones.bloque) return false;
            if (newSelecciones.dia !== '' && newSelecciones.dia !== `${dia}`) return false;
            if (newSelecciones.usuario !== '' && asignado_a !== newSelecciones.usuario) return false;
            if (newSelecciones.impresion !== '' && newSelecciones.impresion !== etiqueta.impreso) return false;
            return true;
        });
        setetiquetas_filtradas(filtradas);
    }

    const panelControl = () => {
        return (<>
            {v.divisorHTML()}
            <div className='bw-1000 round-s shadow-multi p-1 bg-white3 blur-xxl' style={{ position: 'sticky', top: '0', zIndex: '10' }}>
                <div className='row justify-content-evenly w-100 m-0 p-0'>

                    <div className='bw-250 mb-2' key={v.keyGen()}>
                        <div className='w-100 ps-1 text-start text-s text-bold'>Filtrar por bloque</div>
                        <select className='form-control form-control-sm round-xs shadow sm' value={selecciones.bloque} name='bloque' onChange={filttrarEtiquetas}>
                            <option value='' >TODOS LOS BLOQUES</option>
                            {clasificaciones.bloques.map((bloque) => <option key={v.keyGen()} value={bloque}>{bloque}</option>)}
                        </select>
                    </div>
                    <div className='bw-200 mb-2' key={v.keyGen()}>
                        <div className='w-100 ps-1 text-start text-s text-bold'>Filtrar por día</div>
                        <select className='form-control form-control-sm round-xs shadow sm' value={selecciones.dia} name='dia' onChange={filttrarEtiquetas}>
                            <option value='' >TODOS LOS DÍAS DIPONIBLES</option>
                            {clasificaciones.dias.map((dia) => <option key={v.keyGen()} value={dia}>{dias[dia]}</option>)}
                        </select>
                    </div>
                    <div className='bw-250 mb-2' key={v.keyGen()}>
                        <div className='w-100 ps-1 text-start text-s text-bold'>Filtrar por usuario</div>
                        <select className='form-control form-control-sm round-xs shadow sm' value={selecciones.usuario} name='usuario' onChange={filttrarEtiquetas}>
                            <option value='' >TODOS LOS USUARIOS</option>
                            {clasificaciones.usuarios.map((usuario) => <option key={v.keyGen()} value={usuario}>{usuario}</option>)}
                        </select>
                    </div>
                    <div className='bw-200 mb-2' key={v.keyGen()}>
                        <div className='w-100 ps-1 text-start text-s text-bold'>Tipo de etiqueta</div>
                        <select className='form-control form-control-sm round-xs shadow sm' value={selecciones.impresion} name='impresion' onChange={filttrarEtiquetas}>
                            <option value='' >TODAS</option>
                            <option value='SI' >ETIQUETAS IMPRESAS</option>
                            <option value='NO' >ETIQUETAS SIN IMPRIMIR</option>
                        </select>
                    </div>
                    <div className='w-100 text-center p-0 text-bold text-m'>{etiquetas_filtradas.length} ordenes de trabajo</div>
                </div>
            </div>
            {v.divisorHTML(null, 15)}
        </>)
    }

    return (
        <div className='vw-100 vh-100 bg-white4 blur-xl text-center p-1 dosis' style={v.floatPageStyle()}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <CloseButton close={() => close()} floatElement={false} buttonStyle='bw-200 btn btn-sm btn-danger bg-red3 mt-0 me-2 scale-continue-05 border border-warning border-3 text-bold round-xxl' />
                <div className='bw-1300 p-1 round-s bg-dark text-white text-300 h4 m-0'>Etiquetas de ordenes de trabajo</div>
                {panelControl()}
                <HojaEtiquetasBarcodeVer2 etiquetas={etiquetas_filtradas} refrescarEtiquetas={refrescarDesdeHijo} />
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default EtiiquetasBarCodePDF;